import moment from 'moment-timezone';

import { CurrentUserFragment } from 'core/graphql';

import { SuggestedFilter } from './types/filterTypes';

const createDefaultDates = (prop: string) =>
  [
    {
      type: 'suggestion',
      view: 'operator',
      filter: {
        prop,
        operator: 'equals',
        value: moment(new Date()).startOf('day').toDate(),
        negated: false,
      },
    },
    {
      type: 'suggestion',
      view: 'operator',
      filter: {
        prop,
        operator: 'equals',
        value: moment(new Date()).startOf('day').subtract(1, 'day').toDate(),
        negated: false,
      },
    },
    {
      type: 'suggestion',
      view: 'operator',
      filter: {
        prop,
        operator: 'past',
        negated: false,
        start: {
          value: 'NOW',
          modifiers: [
            {
              unit: 'h',
              value: -48,
            },
          ],
        },
        end: {
          round: '',
          value: 'NOW',
        },
      },
    },
    {
      type: 'suggestion',
      view: 'operator',
      filter: {
        prop,
        operator: 'past',
        negated: false,
        start: {
          value: 'NOW',
          modifiers: [
            {
              unit: 'D',
              value: -7,
            },
          ],
        },
        end: {
          round: '',
          value: 'NOW',
        },
      },
    },
    {
      type: 'suggestion',
      view: 'operator',
      filter: {
        prop,
        operator: 'past',
        negated: false,
        start: {
          value: 'NOW',
          modifiers: [
            {
              unit: 'D',
              value: -30,
            },
          ],
        },
        end: {
          round: '',
          value: 'NOW',
        },
      },
    },
  ] as SuggestedFilter[];

export const insightDefaultSuggestions = (
  currentUser: CurrentUserFragment
): SuggestedFilter[] => [
  {
    type: 'filter',
    view: 'field',
    replace: true,
    filter: [
      {
        prop: 'assignee',
        operator: 'equals',
        value: currentUser.username,
        negated: false,
      },
      {
        prop: 'status',
        operator: 'doesNotEqual',
        value: 'closed',
        negated: false,
      },
    ],
  },
  {
    type: 'filter',
    view: 'field',
    replace: true,
    filter: [
      {
        prop: 'assignee',
        operator: 'equals',
        value: null,
        negated: false,
      } as any,
      {
        prop: 'status',
        operator: 'equals',
        value: 'new',
        negated: false,
      },
    ],
  },
  {
    type: 'filter',
    view: 'field',
    replace: true,
    filter: [
      {
        prop: 'status',
        operator: 'doesNotEqual',
        value: 'closed',
        negated: false,
      },
      {
        prop: 'created',
        operator: 'past',
        negated: false,
        start: {
          value: 'NOW',
          modifiers: [
            {
              unit: 'h',
              value: -24,
            },
          ],
        },
        end: {
          round: '',
          value: 'NOW',
        },
      },
    ],
  },
  {
    type: 'suggestion',
    view: 'operator',
    filter: {
      prop: 'assignee',
      operator: 'equals',
      value: currentUser.username,
      negated: false,
    },
  },
  {
    type: 'suggestion',
    view: 'operator',
    filter: {
      prop: 'status',
      operator: 'equals',
      value: 'new',
      negated: false,
    },
  },
  {
    type: 'suggestion',
    view: 'operator',
    filter: {
      prop: 'status',
      operator: 'doesNotEqual',
      value: 'closed',
      negated: false,
    },
  },
  ...createDefaultDates('created'),
];

export const signalsDefaultSuggestions = (): SuggestedFilter[] => [
  ...createDefaultDates('created'),
];

export const entityDefaultSuggestions = (): SuggestedFilter[] => [
  ...createDefaultDates('lastSeen'),
];
